import React, { useState, useEffect, useRef } from 'react';

import Button from './Utilities/CustomButton';
import MedicalInput from './Utilities/MedicalInput';

import '../styles/components/MedicalInfo.scss';
import Fieldset from './Form/Fieldset';
import FormInput from './Form/FormInput';


export default function MedicalInfo({ className, ...props }) {
  const [displayForm, setDisplayForm] = useState('info');
  const [data, setData] = useState({});
  const [show, setShow] = useState(false);
  let timeout = useRef();

  useEffect(() => {
    async function fetchInfo() {
        const info = await window.sdk.session().getMedicalInfo();
        setData(info);
        setShow(true)
    }

    fetchInfo();

    return () => {};
  }, []);  
/*{
    age: 0,
    sexe: '',
    taille: 0,
    poids: 0,
    temperature: 0,
    glycemie: 0,
    oxymetrie: 0,
  }*/
  // -----
  const updateData = (key, value) => {
    let newData = {
      ...data,
      ...{[key]: value}
    }
    setData(newData)
    if (timeout.current)
      clearTimeout(timeout.current);        
    timeout.current = setTimeout(() => {
        window.sdk.session().saveMedicalInfo(newData);
    }, 250);
  }

  const goTo = (eventName) => {
    window.sdk.event().emit(eventName);
  }
  //-------
  return (
    <div className={`medical-info medical-info--${displayForm} ${className ?? ''}`} {...props}>
      {displayForm === 'info' ?
        <>
          <div className='medical-info__form'>
            <Fieldset title="Profil du patient">
              <div className="fieldset-row">
                <FormInput label="Nom du patient" placeholder="Nom" type="text" value={data['patient_lastname']} onChange={(value) => updateData('patient_lastname', value)} />
                <FormInput label="Nom d'usage du patient" placeholder="Nom d'usage" type="text" value={data['patient_nickname']} onChange={(value) => updateData('patient_nickname', value)} />
              </div>
              <div className="fieldset-row">
                <FormInput label="Prénom du patient" placeholder="Prénom" type="text" value={data['patient_firstname']} onChange={(value) => updateData('patient_firstname', value)} />
                <FormInput label="Date de naissance" placeholder="XX/XX/XXXX"  min="1910-01-01"  max={new Date().toISOString().split('T')[0]} type="date" value={data['patient_birthday']} onChange={(value) => updateData('patient_birthday', value)} />
              </div>
            </Fieldset>
            <Fieldset title="Équipe médicale">
              <div className="fieldset-row">
                <FormInput label="Nom, prénom du soignant en présentiel" placeholder="Nom, prénom" type="text" value={data['soignant_name']} onChange={(value) => updateData('soignant_name', value)} />
                <FormInput label="Numéro RPPS" placeholder="" type="text" value={data['soignant_rpps']} onChange={(value) => updateData('soignant_rpps', value)} />
              </div>
              <div className="fieldset-row">
                <FormInput label="Nom, prénom du médecin" placeholder="Nom, prénom" type="text" value={data['medecin_name']} onChange={(value) => updateData('medecin_name', value)} />
                <FormInput label="Numéro RPPS" placeholder="" type="text" value={data['medecin_rpps']} onChange={(value) => updateData('medecin_rpps', value)} />
              </div>
            </Fieldset>
            <Fieldset title="Informations de la consultation">
              <div className="fieldset-row">
                <FormInput id="motif_consultation" label="Motif de la consulation" placeholder="Motif de la consulation" type="text" value={data['consulation_motif']} onChange={(value) => updateData('consulation_motif', value)} />
                <FormInput label="Lieu de soin" placeholder="Code postal" type="zipcode" value={data['patient_zipcode']} onChange={(value) => updateData('patient_zipcode', value)} />
              </div>
            </Fieldset>
            <div className={'onboarding-config__actions_mobile medical-info__actions'}>
              <Button className={'medical-info__action'} outline={true}  onClick={() => { goTo('welcome') }}>Précédent</Button>
              <Button className={'medical-info__action'} onClick={() => { setDisplayForm('data') }}>Suivant</Button>
            </div>
          </div>  
          <div className={'onboarding-config__actions medical-info__actions'}>
            <Button className={'medical-info__action'} outline={true} onClick={() => { goTo('welcome') }}>Précédent</Button>
            <Button className={'medical-info__action'} onClick={() => { setDisplayForm('data') }}>Suivant</Button>
          </div>
        </>
        :
        <>
          <h3 className={`medical-info__title`}>Sélectionnez et remplissez les paramètres afin de les partager avec le médecin lors de la consultation</h3>
          <h4 className={`medical-info__subtitle`}>Ces informations aideront le médecin à établir un meilleur diagnostic</h4>
          {show &&
            <div className={'medical-info__inputsWrap'}>
              <div className={'medical-info__inputs'}>
                <MedicalInput
                  className={'medical-info__input'}
                  label='Sexe'
                  type='select'
                  value={data['sexe']}
                  options={{ male: 'Homme', female: 'Femme' }}
                  onChange={(value) => updateData('sexe', value)}
                  icon={<span className='icon-gender' />}
                />
                <MedicalInput
                  className={'medical-info__input'}
                  label='Age'
                  value={data['age']}
                  min={0}
                  max={120}
                  step={1}
                  suffix={'ans'}
                  initValue={40}
                  onChange={(value) => updateData('age', value)}
                  icon={<span className='icon-cake' />}
                />
                <MedicalInput
                  className={'medical-info__input'}
                  label='Taille'
                  value={data['taille']}
                  min={50}
                  max={250}
                  step={1}
                  suffix={'cm'}
                  initValue={170}
                  onChange={(value) => updateData('taille', value)}
                  icon={<span className='icon-meter' />}
                />
                <MedicalInput
                  className={'medical-info__input'}
                  label='Poids'
                  value={data['poids']}
                  min={2}
                  max={200}
                  step={1}
                  suffix={'kg'}
                  initValue={70}
                  onChange={(value) => updateData('poids', value)}
                  icon={<span className='icon-weight' />}
                />
                <MedicalInput
                  className={'medical-info__input'}
                  label='Température'
                  value={data['temperature']}
                  min={25}
                  max={43}
                  step={0.5}
                  suffix={'°C'}
                  initValue={37.5}
                  onChange={(value) => updateData('temperature', value)}
                  icon={<span className='icon-temp' />}
                />
                <MedicalInput
                  className={'medical-info__input'}
                  label='Glycémie'
                  value={data['glycemie']}
                  min={0.3}
                  max={10}
                  step={0.1}
                  suffix={'mg/dl'}
                  initValue={0.9}
                  onChange={(value) => updateData('glycemie', value)}
                  icon={<span className='icon-glycemie' />}
                />
                <MedicalInput
                  className={'medical-info__input'}
                  label='Oxymetrie'
                  value={data['oxymetrie']}
                  min={0}
                  max={100}
                  step={1}
                  initValue={100}
                  suffix={'%'}
                  onChange={(value) => updateData('oxymetrie', value)}
                  icon={<span className='icon-oxymetrie' />}
                />
              </div>
              <div className={'onboarding-config__actions_mobile medical-info__actions'}>
                <Button className={'medical-info__action'} outline={true} onClick={() => { setDisplayForm('info') }}>Précédent</Button>
                <Button className={'medical-info__action'} onClick={() => { goTo('onBoarding') }}>Suivant</Button>
              </div>
            </div>
          }
          <div className={'onboarding-config__actions medical-info__actions'}>
            <Button className={'medical-info__action'} outline={true} onClick={() => { setDisplayForm('info') }}>Précédent</Button>
            <Button className={'medical-info__action'} onClick={() => { goTo('onBoarding') }}>Suivant</Button>
          </div>
        </>
      }
    </div>
  );
}